// extracted by mini-css-extract-plugin
export default {"root":"plain-paging_root__+rsEv","pages":"plain-paging_pages__ekF6c","placeHolderShimmer":"plain-paging_placeHolderShimmer__taqjG"};